var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.592,
    height: 104.741,
    viewBox: "0 0 104.592 104.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot_2023-02-23_at_4.19.40_PM_adobe_express",
    "data-name": "Screenshot 2023-02-23 at 4.19.40 PM_adobe_express",
    transform: "translate(-282.203 -117.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M315.676,222.324q35.018.036,70.035.017c.29,0,.58-.054,1.084-.1-.44-.465-.7-.755-.974-1.029q-13.793-13.8-27.587-27.591c-1.806-1.808-3.587-3.64-5.257-5.556,7.946-3.095,15.031-7.473,20.385-14.23,6.248-7.885,7.965-16.87,5.717-26.574-1.619-6.989-5.623-12.592-11.119-17.071a54.541,54.541,0,0,0-34.786-12.5c-16.429-.164-32.86-.04-49.29-.031a5.935,5.935,0,0,0-1.514.268,5.239,5.239,0,0,0-.164.922q-.009,34.159.012,68.319C282.219,187.517,315.227,222.324,315.676,222.324Z",
    transform: "translate(0 0)",
    fill: "#defefc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M283.607,117.823a11.2,11.2,0,0,1,1.377-.167c16.43-.009,32.862-.133,49.29.031a54.541,54.541,0,0,1,34.786,12.5c5.5,4.48,9.5,10.083,11.119,17.071,2.249,9.7.532,18.689-5.717,26.574-5.355,6.757-12.439,11.135-20.508,14.257a2.824,2.824,0,0,1-.863-.6c-.071-.085-.132-.117-.208-.2a.771.771,0,0,0-.206-.167s0,0-.014-.06a2.832,2.832,0,0,0-.419-.374s0,.005-.014-.056c-.086-.1-.159-.134-.252-.237a6.008,6.008,0,0,0-.537-.618q-30.164-30.172-60.327-60.344C288.6,122.906,286.11,120.358,283.607,117.823Z",
    transform: "translate(-1.101 0)",
    fill: "#ff6900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M282.438,118.852c2.571,2.485,5.059,5.033,7.577,7.553q30.159,30.176,60.327,60.344a2.951,2.951,0,0,1,.51.657.621.621,0,0,0,.292.26s0-.006.008.064a2.1,2.1,0,0,0,.423.369s.006-.007.024.045a.82.82,0,0,0,.2.173c.062.032.123.063.191.239a2.274,2.274,0,0,1-1.215.6q-29.514.028-59.028.005c-.323,0-.647-.036-.97-.041-2.623-.048-5.247-.095-7.871-.128-.12,0-.242.135-.364.207a3.807,3.807,0,0,1-.323-1.055q-.026-34.159-.012-68.319A3.038,3.038,0,0,1,282.438,118.852Z",
    transform: "translate(0 -0.979)",
    fill: "#f79e00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M283.891,442.062c.095-.141.217-.277.337-.276,2.624.033,5.247.08,7.871.128.324.006.647.041.97.042q29.514.009,59.028-.005a2.683,2.683,0,0,0,1.224-.547,4.793,4.793,0,0,1,.8.5c1.854,1.841,3.635,3.674,5.441,5.482q13.788,13.8,27.587,27.591c.275.275.534.564.974,1.029-.5.05-.794.1-1.084.1q-35.018.006-70.035-.017a2.008,2.008,0,0,1-1.328-.5Q299.769,458.888,283.891,442.062Z",
    transform: "translate(-1.323 -253.773)",
    fill: "#00ba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M601.416,437.643a.913.913,0,0,1-.414-.3A.913.913,0,0,1,601.416,437.643Z",
    transform: "translate(-249.853 -250.588)",
    fill: "#4809c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M599.982,436.277a.31.31,0,0,1-.258-.131A.31.31,0,0,1,599.982,436.277Z",
    transform: "translate(-248.851 -249.651)",
    fill: "#4809c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M603.254,439.365c-.045.016-.105-.024-.187-.114C603.109,439.237,603.175,439.273,603.254,439.365Z",
    transform: "translate(-251.471 -252.083)",
    fill: "#4809c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.15bcb82b599b828a9ca7438dcd15106d.svg";
export { ForwardRef as ReactComponent };